import React from 'react';

/**
 * Libellés & classes d'affichage des statuts de domaine (mode admin).
 * Centralisés pour la liste et le détail (DomainTab, DomainDetails, RegisterDomainModal).
 */

// Statuts du document domaine users/{uid}/domains
export const DOMAIN_STATUS_LABELS = {
  active: 'Actif',
  registration_failed: 'Échec réservation',
  pending: 'En attente',
  processing: 'En cours',
  provisioning: 'Provisionnement',
  expired: 'Expiré',
  cancelled: 'Annulé'
};

// Statuts du suivi temps réel domainRegistrations/{id}
export const TRACKING_STATUS_LABELS = {
  pending: 'En attente',
  in_progress: 'En cours',
  completed: 'Réservé',
  failed: 'Échec'
};

export const DNS_STATUS_LABELS = {
  active: 'DNS actifs',
  pending: 'DNS en attente',
  failed: 'Échec DNS',
  configured: 'Configurés',
  not_configured: 'Non configurés'
};

const STYLE_BY_STATUS = {
  active: 'bg-success/20 text-success border border-success/30',
  completed: 'bg-success/20 text-success border border-success/30',
  registration_failed: 'bg-error/20 text-error border border-error/30',
  failed: 'bg-error/20 text-error border border-error/30',
  expired: 'bg-warning/20 text-warning border border-warning/30',
  pending: 'bg-warning/20 text-warning border border-warning/30',
  in_progress: 'bg-info/20 text-info border border-info/30',
  processing: 'bg-info/20 text-info border border-info/30',
  provisioning: 'bg-info/20 text-info border border-info/30'
};

const DEFAULT_STYLE = 'bg-base-300 text-base-content border border-base-300';

/**
 * Classe CSS d'un badge de statut.
 * @param {string} status
 * @returns {string}
 */
export const statusBadgeClass = (status) =>
  STYLE_BY_STATUS[status] || DEFAULT_STYLE;

/**
 * Pastille de statut générique.
 * @param {Object} props
 * @param {string} props.label - Libellé affiché
 * @param {string} [props.status] - Clé de statut (couleur)
 * @param {string} [props.className] - Classes additionnelles
 */
export const StatusPill = ({ label, status, className = '' }) => (
  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${statusBadgeClass(status)} ${className}`}>
    {label}
  </span>
);
